var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#249995",
    d: "M12.995 3.705l.848.86a.42.42 0 01.004.586l-6.65 6.9a.42.42 0 01-.602.004l-3.394-3.44a.42.42 0 010-.59l.849-.859a.42.42 0 01.597 0L6.89 9.438l5.503-5.729a.42.42 0 01.602-.004z"
  })));
}
export default SvgGreenTick;